export default class Group {
  name!: string | null;
  deleted!: string | null;
  created!: string | null;
  adminpanelGroup!: any | null;
  objectClass!: string[] | null;
  dn!: string | null;
  cn!: string | null;
  description!: string | null;
  mailLocalAddress!: string[] | null;
  entryParentId!: number | null;
  uniqueMember!: string[] | null;
  syncedWithSeafile!: boolean | null;

  constructor() {
    this.name = null;
    this.deleted = null;
    this.created = null;
    this.adminpanelGroup = null;
    this.objectClass = null;
    this.dn = null;
    this.cn = null;
    this.description = null;
    this.mailLocalAddress = null;
    this.entryParentId = null;
    this.uniqueMember = null;
    this.syncedWithSeafile = null;
  }
}
